import { register } from '@Ravnur-Inc/core/ui-kit/icon/icon-storage';

/* eslint max-len: 0 */

register('navigate', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12.3327 2.4987C11.8724 2.4987 11.4993 2.1256 11.4993 1.66536C11.4993 1.20513 11.8724 0.832031 12.3327 0.832031H16.4993C16.9596 0.832031 17.3327 1.20513 17.3327 1.66536V5.83203C17.3327 6.29227 16.9596 6.66536 16.4993 6.66536C16.0391 6.66536 15.666 6.29227 15.666 5.83203V3.67721L8.75527 10.588C8.42983 10.9134 7.9022 10.9134 7.57676 10.588C7.25132 10.2625 7.25132 9.73488 7.57676 9.40944L14.4875 2.4987H12.3327ZM0.666016 3.33203C0.666016 2.87179 1.03911 2.4987 1.49935 2.4987H8.99935C9.45959 2.4987 9.83268 2.87179 9.83268 3.33203C9.83268 3.79227 9.45959 4.16536 8.99935 4.16536H2.33268V15.832H13.9993V9.16536C13.9993 8.70513 14.3724 8.33203 14.8327 8.33203C15.2929 8.33203 15.666 8.70513 15.666 9.16536V16.6654C15.666 17.1256 15.2929 17.4987 14.8327 17.4987H1.49935C1.03911 17.4987 0.666016 17.1256 0.666016 16.6654V3.33203Z',
    },
  ],
});

register('spinner', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z',
    },
  ],
});

register('delete', {
  width: 15,
  height: 15,
  paths: [
    {
      d: 'M11.2591 3.22726H14.8182C15.1939 3.22726 15.5 3.53272 15.5 3.90908C15.5 4.28544 15.1939 4.5909 14.8182 4.5909H13.7886L12.8402 14.3068C12.7536 14.9927 12.1686 15.5054 11.4766 15.5H4.52273C3.82727 15.5006 3.24227 14.9777 3.16591 14.2863L2.21068 4.5909H1.18182C0.805455 4.5909 0.5 4.28544 0.5 3.90908C0.5 3.53272 0.805455 3.22726 1.18182 3.22726H4.74023L5.03409 2.04772C5.2625 1.13818 6.07932 0.5 7.0175 0.5H8.98182C9.92 0.5 10.7368 1.13818 10.9652 2.04772L11.2591 3.22726ZM4.51523 14.1363H11.4705L12.4107 4.5909H3.58864L4.51523 14.1363ZM6.35682 2.38181L6.14545 3.22726H9.85386L9.68341 2.38181C9.60705 2.07022 9.32341 1.85409 9.00159 1.86363H7.03864C6.7175 1.85409 6.43386 2.07022 6.35682 2.38181ZM5.95455 7.31816V11.4091C5.95455 11.7854 6.26 12.0909 6.63636 12.0909C7.01205 12.0909 7.31818 11.7854 7.31818 11.4091V7.31816C7.31818 6.9418 7.01205 6.63635 6.63636 6.63635C6.26 6.63635 5.95455 6.9418 5.95455 7.31816ZM8.68182 11.4091V7.31816C8.68182 6.9418 8.98727 6.63635 9.36364 6.63635C9.73932 6.63635 10.0455 6.9418 10.0455 7.31816V11.4091C10.0455 11.7854 9.73932 12.0909 9.36364 12.0909C8.98727 12.0909 8.68182 11.7854 8.68182 11.4091Z',
    },
  ],
});

register('edit', {
  width: 15,
  height: 15,
  paths: [
    {
      d: 'M10.3676 1.29481C11.4271 0.235064 13.1453 0.235064 14.2048 1.29481C15.2651 2.35456 15.2651 4.07273 14.2048 5.13248L4.75623 14.5814C4.66146 14.6761 4.54078 14.7406 4.40919 14.7669L0.811928 15.4864C0.336703 15.5814 -0.0812504 15.1628 0.013522 14.6881L0.732837 11.0903C0.759428 10.959 0.823519 10.8384 0.918291 10.7437L10.3676 1.29481ZM11.3269 6.09186L9.40826 4.17303L1.73238 11.8484L1.25306 14.2469L3.65169 13.7671L11.3269 6.09186ZM13.2455 2.25426C12.7157 1.72435 11.8567 1.72435 11.3269 2.25426L10.3676 3.21364L12.2862 5.13248L13.2455 4.17303C13.7753 3.64319 13.7753 2.7841 13.2455 2.25426Z',
    },
  ],
});

register('camera', {
  width: 21,
  height: 21,
  paths: [
    {
      d: 'M21.2583 3.87313V16.6981C21.2583 17.1703 20.8752 17.5531 20.4033 17.5531H1.59328C1.36671 17.5532 1.14868 17.4631 0.988796 17.3028C0.828056 17.1424 0.738281 16.9249 0.738281 16.6981V3.87313C0.738281 3.64634 0.828056 3.42884 0.988796 3.26849C1.14868 3.10813 1.36671 3.01807 1.59328 3.01813H6.10683L6.76689 1.03759C6.88317 0.688506 7.21063 0.453082 7.57828 0.453125H14.4183C14.7859 0.453099 15.1134 0.688515 15.2297 1.03759L15.8897 3.01813H20.4033C20.6299 3.01807 20.8479 3.10813 21.0078 3.26849C21.1685 3.42884 21.2583 3.64634 21.2583 3.87313ZM2.44828 4.72813V15.8431H19.5483V4.72813H15.2733C14.9056 4.72815 14.5782 4.49273 14.4619 4.14366L13.8018 2.16313H8.19474L7.53468 4.14366C7.4184 4.49274 7.09093 4.72817 6.72328 4.72813H2.44828ZM10.9983 5.58313C8.63763 5.58313 6.72328 7.49713 6.72328 9.85813C6.72328 12.2191 8.63763 14.1331 10.9983 14.1331C13.3589 14.1331 15.2733 12.2191 15.2733 9.85813C15.2707 7.49824 13.3581 5.5859 10.9983 5.58313ZM10.9983 12.4231C9.58155 12.4231 8.43328 11.2748 8.43328 9.85813C8.43328 8.44148 9.58155 7.29313 10.9983 7.29313C12.415 7.29313 13.5633 8.44148 13.5633 9.85813C13.5616 11.2741 12.4142 12.4216 10.9983 12.4231Z',
    },
  ],
});

register('sidebar-toggle', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3.95944 10.6316C3.61024 10.2806 3.61024 9.71356 3.95944 9.36256L10.2684 3.07156C10.6257 2.76576 11.1576 2.78633 11.4906 3.11876C11.8227 3.45119 11.8434 3.98348 11.5374 4.34056L6.76744 9.10156L18.9984 9.10156C19.4955 9.10156 19.8984 9.50449 19.8984 10.0016C19.8984 10.4986 19.4955 10.9016 18.9984 10.9016L6.76744 10.9016L11.5284 15.6626C11.8344 16.0197 11.8137 16.5519 11.4816 16.8844C11.1486 17.2168 10.6167 17.2374 10.2594 16.9316L3.95944 10.6316ZM0.998438 0.101562C1.49524 0.101562 1.89844 0.50451 1.89844 1.00156L1.89844 19.0016C1.89844 19.4986 1.49524 19.9016 0.998438 19.9016C0.501638 19.9016 0.0984383 19.4986 0.0984383 19.0016L0.0984383 1.00156C0.0984383 0.50451 0.501638 0.101562 0.998438 0.101562Z',
    },
  ],
});

register('my-profile', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7.40556 0.453125H10.5925C10.8938 0.453125 11.1601 0.649891 11.2552 0.942535L11.7501 2.46156C11.9402 2.54456 12.1262 2.63615 12.3072 2.73561L13.7759 2.18466C13.8549 2.15533 13.936 2.1403 14.0164 2.1403C14.2247 2.1403 14.4274 2.23618 14.563 2.41005L16.5497 4.96013C16.7377 5.20054 16.7538 5.53683 16.5903 5.79585L15.7339 7.14602C15.7878 7.34564 15.8339 7.54742 15.8709 7.75277L17.2138 8.58849C17.4703 8.74805 17.5983 9.05858 17.5319 9.35838L16.823 12.5388C16.7559 12.8393 16.5092 13.0619 16.2093 13.0919L14.6434 13.2486C14.5239 13.416 14.3981 13.5785 14.2652 13.7344L14.4652 15.3315C14.5036 15.637 14.3456 15.9332 14.0744 16.067L11.2041 17.4823C11.107 17.5302 11.0035 17.5531 10.9008 17.5531C10.7162 17.5531 10.5338 17.478 10.3996 17.3363L9.30136 16.1793C9.26011 16.1808 9.21957 16.1836 9.17833 16.1863C9.11891 16.1904 9.05949 16.1944 8.99937 16.1944C8.93856 16.1944 8.87914 16.1904 8.82042 16.1863C8.77917 16.1836 8.73863 16.1808 8.69809 16.1793L7.60059 17.337C7.46568 17.4787 7.28393 17.5531 7.09868 17.5531C6.99592 17.5531 6.89247 17.5302 6.7953 17.483L3.92434 16.0677C3.65311 15.9346 3.49653 15.6384 3.53428 15.3329L3.7335 13.7352C3.60068 13.5799 3.47486 13.4168 3.35532 13.25L1.78877 13.0933C1.49028 13.0633 1.24282 12.8401 1.17571 12.5403L0.466887 9.36052C0.399779 9.06001 0.527703 8.75019 0.78495 8.58992L2.12781 7.7542C2.16346 7.54813 2.21099 7.34636 2.26412 7.14673L1.4071 5.79728C1.24352 5.53826 1.2596 5.20197 1.44764 4.96156L3.43431 2.41076C3.56923 2.23689 3.77195 2.14102 3.98096 2.14102C4.06135 2.14102 4.14244 2.15604 4.22143 2.18538L5.68942 2.73632C5.87117 2.63687 6.05781 2.54528 6.24795 2.46156L6.74287 0.942535C6.83794 0.649891 7.10497 0.453125 7.40556 0.453125ZM10.4379 2.91971L10.0991 1.87813H7.89929L7.56123 2.91971C7.43349 3.31203 7.14836 3.62979 6.77784 3.79265C6.62328 3.86069 6.47154 3.93597 6.32756 4.01487C6.12007 4.12923 5.88929 4.18786 5.6578 4.18786C5.49406 4.18786 5.32962 4.15818 5.17224 4.09955L4.16723 3.72171L2.79594 5.48496L3.38313 6.41435C3.60263 6.76034 3.66685 7.18596 3.56099 7.58478C3.5137 7.75995 3.47771 7.92064 3.45018 8.07554C3.37819 8.48233 3.13965 8.83846 2.79524 9.05343L1.87422 9.62743L2.36331 11.8271L3.43889 11.935C3.83976 11.9748 4.20464 12.1883 4.44177 12.522C4.54411 12.6653 4.64433 12.7942 4.74666 12.9158C5.01203 13.227 5.13412 13.6403 5.08331 14.05L4.9471 15.1488L6.92887 16.1281L7.68262 15.3305C7.9487 15.0489 8.31499 14.8918 8.69539 14.8918C8.71515 14.8918 9.30446 14.8918 9.30446 14.8918C9.68487 14.8918 10.0504 15.0489 10.3172 15.3305L11.071 16.1274L13.0535 15.1481L12.9165 14.0493C12.865 13.6396 12.9871 13.227 13.2525 12.9151C13.3555 12.7935 13.455 12.6646 13.5574 12.5213C13.7952 12.1876 14.1594 11.9741 14.5603 11.9343L15.6358 11.8257L16.1242 9.62598L15.2039 9.05271C14.8588 8.83773 14.621 8.48161 14.5483 8.07482C14.5207 7.91992 14.4847 7.75923 14.4382 7.58406C14.3309 7.18523 14.3958 6.7589 14.6153 6.41291L15.2025 5.48424L13.8305 3.72099L12.8255 4.09883C12.6681 4.15818 12.5037 4.18714 12.3392 4.18714C12.1084 4.18714 11.8784 4.12923 11.6702 4.01414C11.5262 3.93524 11.3752 3.85997 11.2206 3.79265C10.8508 3.62979 10.5649 3.31203 10.4379 2.91971ZM5.43672 9.00313C5.43672 7.0352 7.03129 5.44063 8.99922 5.44063C10.9671 5.44063 12.5617 7.0352 12.5617 9.00313C12.5617 10.9711 10.9671 12.5656 8.99922 12.5656C7.03129 12.5656 5.43672 10.9711 5.43672 9.00313ZM11.1367 9.00313C11.1367 7.82465 10.1777 6.86563 8.99922 6.86563C7.82074 6.86563 6.86172 7.82465 6.86172 9.00313C6.86172 10.1816 7.82074 11.1406 8.99922 11.1406C10.1777 11.1406 11.1367 10.1816 11.1367 9.00313Z',
    },
  ],
});

register('following', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7.56597 1.5C6.2006 1.5 5.09375 2.60685 5.09375 3.97222C5.09375 5.33759 6.2006 6.44444 7.56597 6.44444C8.93134 6.44444 10.0382 5.33759 10.0382 3.97222C10.0382 2.60685 8.93134 1.5 7.56597 1.5ZM3.59375 3.97222C3.59375 1.77842 5.37217 0 7.56597 0C9.75977 0 11.5382 1.77842 11.5382 3.97222C11.5382 6.16602 9.75977 7.94444 7.56597 7.94444C5.37217 7.94444 3.59375 6.16602 3.59375 3.97222ZM1.93687 10.8275C2.68181 10.0826 3.69216 9.66406 4.74566 9.66406H10.3845C11.438 9.66406 12.4484 10.0826 13.1933 10.8275C13.9383 11.5724 14.3568 12.5828 14.3568 13.6363V15.2474C14.3568 15.6616 14.021 15.9974 13.6068 15.9974C13.1926 15.9974 12.8568 15.6616 12.8568 15.2474V13.6363C12.8568 12.9806 12.5963 12.3518 12.1327 11.8882C11.669 11.4245 11.0402 11.1641 10.3845 11.1641H4.74566C4.08999 11.1641 3.46117 11.4245 2.99753 11.8882C2.5339 12.3518 2.27344 12.9806 2.27344 13.6363V15.2474C2.27344 15.6616 1.93765 15.9974 1.52344 15.9974C1.10922 15.9974 0.773438 15.6616 0.773438 15.2474V13.6363C0.773438 12.5828 1.19194 11.5724 1.93687 10.8275ZM19.7777 6.11627C20.0706 5.82337 20.0706 5.3485 19.7777 5.05561C19.4848 4.76271 19.01 4.76271 18.7171 5.05561L16.0252 7.7475L14.9444 6.66672C14.6515 6.37383 14.1766 6.37383 13.8837 6.66672C13.5908 6.95961 13.5908 7.43449 13.8837 7.72738L15.4948 9.33849C15.6355 9.47914 15.8263 9.55816 16.0252 9.55816C16.2241 9.55816 16.4149 9.47914 16.5555 9.33849L19.7777 6.11627Z',
    },
  ],
});

register('my-favorites', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
    },
  ],
});

register('viewing-history', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.25 9C17.25 13.5562 13.5562 17.25 9 17.25C4.44375 17.25 0.75 13.5562 0.75 9C0.75 4.44375 4.44375 0.75 9 0.75C13.5562 0.75 17.25 4.44375 17.25 9ZM15.75 9C15.75 5.27175 12.7283 2.25 9 2.25C5.27175 2.25 2.25 5.27175 2.25 9C2.25 12.7283 5.27175 15.75 9 15.75C12.7283 15.75 15.75 12.7283 15.75 9ZM8.25 4.5C8.25 4.086 8.586 3.75 9 3.75C9.414 3.75 9.75 4.086 9.75 4.5V8.6925L11.775 10.725C12.03 11.0228 12.0128 11.466 11.736 11.7435C11.4585 12.0202 11.0153 12.0375 10.7175 11.7825L8.4675 9.5325C8.32725 9.39075 8.2485 9.1995 8.25 9V4.5Z',
    },
  ],
});

register('viewing-history', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.25 9C17.25 13.5562 13.5562 17.25 9 17.25C4.44375 17.25 0.75 13.5562 0.75 9C0.75 4.44375 4.44375 0.75 9 0.75C13.5562 0.75 17.25 4.44375 17.25 9ZM15.75 9C15.75 5.27175 12.7283 2.25 9 2.25C5.27175 2.25 2.25 5.27175 2.25 9C2.25 12.7283 5.27175 15.75 9 15.75C12.7283 15.75 15.75 12.7283 15.75 9ZM8.25 4.5C8.25 4.086 8.586 3.75 9 3.75C9.414 3.75 9.75 4.086 9.75 4.5V8.6925L11.775 10.725C12.03 11.0228 12.0128 11.466 11.736 11.7435C11.4585 12.0202 11.0153 12.0375 10.7175 11.7825L8.4675 9.5325C8.32725 9.39075 8.2485 9.1995 8.25 9V4.5Z',
    },
  ],
});

register('my-playlists', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M2.18098 0.758528C1.3494 0.218287 0.25 0.81509 0.25 1.80675V8.2875C0.25 9.27917 1.3494 9.87596 2.18098 9.33572L7.16884 6.09535C7.92754 5.60246 7.92753 4.49179 7.16884 3.99891L2.18098 0.758528ZM1.75 7.82697V2.26729L6.02896 5.04713L1.75 7.82697ZM9.55003 1.64062C9.10818 1.64062 8.75 1.99881 8.75 2.44065C8.75 2.8825 9.10818 3.24068 9.55003 3.24068H14.9505C15.3923 3.24068 15.7505 2.8825 15.7505 2.44065C15.7505 1.99881 15.3923 1.64062 14.9505 1.64062H9.55003ZM9.55003 6.7422C9.10818 6.7422 8.75 7.10038 8.75 7.54222C8.75 7.98407 9.10818 8.34225 9.55003 8.34225H14.9494C15.3913 8.34225 15.7494 7.98407 15.7494 7.54222C15.7494 7.10038 15.3913 6.7422 14.9494 6.7422H9.55003ZM0.25 12.6438C0.25 12.2019 0.608185 11.8438 1.05003 11.8438H14.9489C15.3907 11.8438 15.7489 12.2019 15.7489 12.6438C15.7489 13.0856 15.3907 13.4438 14.9489 13.4438H1.05003C0.608185 13.4438 0.25 13.0856 0.25 12.6438Z',
    },
  ],
});

register('my-audios', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10.3025 2.93589C10.5437 3.05179 10.697 3.29565 10.697 3.56319V16.4213C10.697 16.6889 10.5437 16.9328 10.3025 17.0487C10.0614 17.1646 9.77515 17.132 9.56623 16.9648L5.16468 13.4436H1.73506C1.35067 13.4436 1.03906 13.132 1.03906 12.7476V7.23695C1.03906 6.85256 1.35067 6.54095 1.73506 6.54095H5.16468L9.56623 3.01971C9.77515 2.85257 10.0614 2.81999 10.3025 2.93589ZM9.30502 5.01131L5.84361 7.78044C5.7202 7.87917 5.56686 7.93295 5.40882 7.93295H2.43106V12.0516H5.40882C5.56686 12.0516 5.7202 12.1054 5.84361 12.2041L9.30502 14.9732V5.01131ZM12.7606 6.25065C13.0324 5.97889 13.4731 5.97896 13.7449 6.2508C14.7362 7.24249 15.2932 8.58732 15.2932 9.98956C15.2932 11.3918 14.7362 12.7366 13.7449 13.7283C13.4731 14.0002 13.0324 14.0002 12.7606 13.7285C12.4887 13.4567 12.4887 13.016 12.7604 12.7442C13.4908 12.0135 13.9012 11.0227 13.9012 9.98956C13.9012 8.95643 13.4908 7.96559 12.7604 7.23495C12.4887 6.9631 12.4887 6.52242 12.7606 6.25065ZM16.4128 3.36214C16.155 3.07696 15.7149 3.05472 15.4297 3.31245C15.1445 3.57019 15.1223 4.01031 15.38 4.29549C16.7866 5.85183 17.5706 7.87891 17.5706 9.98678C17.5706 12.1239 16.7647 14.1779 15.3212 15.7425C15.0605 16.025 15.0782 16.4654 15.3608 16.726C15.6433 16.9867 16.0836 16.9689 16.3443 16.6864C18.0246 14.8652 18.9626 12.4744 18.9626 9.98678C18.9626 7.53322 18.05 5.17374 16.4128 3.36214Z',
    },
  ],
});

register('my-videos', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M0 3.6276C0 2.08581 1.24987 0.835938 2.79167 0.835938H13.2083C14.7501 0.835938 16 2.08581 16 3.6276V12.3776C16 13.9194 14.7501 15.1693 13.2083 15.1693H2.79167C1.24987 15.1693 0 13.9194 0 12.3776V3.6276ZM2.79167 2.2526C2.03228 2.2526 1.41667 2.86821 1.41667 3.6276V12.3776C1.41667 13.137 2.03228 13.7526 2.79167 13.7526H13.2083C13.9677 13.7526 14.5833 13.137 14.5833 12.3776V3.6276C14.5833 2.86821 13.9677 2.2526 13.2083 2.2526H2.79167Z',
    },
    {
      d: 'M11.8586 0.910873C12.2085 1.08582 12.3503 1.5113 12.1754 1.8612L10.092 6.02787C9.91709 6.37777 9.49161 6.5196 9.14171 6.34464C8.79181 6.16969 8.64999 5.74422 8.82494 5.39432L10.9083 1.22765C11.0832 0.877748 11.5087 0.735923 11.8586 0.910873Z',
    },
    {
      d: 'M7.27266 0.910873C7.62256 1.08582 7.76439 1.5113 7.58944 1.8612L5.5061 6.02787C5.33115 6.37777 4.90568 6.5196 4.55577 6.34464C4.20587 6.16969 4.06405 5.74422 4.239 5.39432L6.32233 1.22765C6.49728 0.877748 6.92276 0.735923 7.27266 0.910873Z',
    },
    {
      d: 'M0 5.70833C0 5.31713 0.317132 5 0.708333 5H14.875C15.2662 5 15.5833 5.31713 15.5833 5.70833C15.5833 6.09953 15.2662 6.41667 14.875 6.41667H0.708333C0.317132 6.41667 0 6.09953 0 5.70833Z',
    },
  ],
});

register('cloud-upload', {
  width: 60,
  height: 60,
  paths: [
    {
      d: 'M38.7451 33.707C38.9401 33.902 39.1961 34 39.4521 34C39.7081 34 39.9641 33.902 40.1591 33.707C40.5501 33.316 40.5501 32.684 40.1591 32.293L30.1641 22.299C30.0711 22.204 29.9581 22.128 29.8321 22.077C29.7271 22.033 29.6171 22.017 29.5051 22.011C29.4871 22.01 29.4721 22 29.4531 22H29.4521C29.3211 22 29.1911 22.027 29.0681 22.078C28.9921 22.109 28.9311 22.163 28.8661 22.212C28.8261 22.241 28.7801 22.257 28.7441 22.293L18.7441 32.293C18.3531 32.684 18.3531 33.316 18.7441 33.707C19.1351 34.098 19.7671 34.098 20.1581 33.707L28.4531 25.412V59C28.4531 59.552 28.9011 60 29.4531 60C30.0051 60 30.4531 59.552 30.4531 59V25.416L38.7451 33.707ZM23.4531 38H8.45312C5.14412 38 2.45312 35.309 2.45312 32C2.45312 28.691 5.14412 26 8.45312 26C9.00513 26 9.45312 25.552 9.45312 25C9.45312 24.448 9.00513 24 8.45312 24C4.04213 24 0.453125 27.589 0.453125 32C0.453125 36.411 4.04213 40 8.45312 40H23.4531C24.0051 40 24.4531 39.552 24.4531 39C24.4531 38.448 24.0051 38 23.4531 38ZM55.3701 18.193C54.9181 17.875 54.2941 17.983 53.9761 18.433C53.6581 18.884 53.7651 19.508 54.2161 19.827C56.8691 21.702 58.4531 24.757 58.4531 28C58.4531 33.514 53.9671 38 48.4531 38H35.4531C34.9011 38 34.4531 38.448 34.4531 39C34.4531 39.552 34.9011 40 35.4531 40H48.4531C55.0701 40 60.4531 34.617 60.4531 28C60.4531 24.108 58.5531 20.442 55.3701 18.193ZM24.8201 8.207C27.4311 4.32 31.7801 2 36.4531 2C44.1731 2 50.4531 8.28 50.4531 16C50.4531 17.269 50.2841 18.525 49.9501 19.734C49.8031 20.266 50.1161 20.817 50.6481 20.964C50.7371 20.989 50.8271 21 50.9141 21C51.3531 21 51.7561 20.709 51.8781 20.266C52.2601 18.884 52.4531 17.448 52.4531 16C52.4531 7.178 45.2751 0 36.4531 0C31.1121 0 26.1421 2.651 23.1601 7.092C22.8521 7.551 22.9741 8.172 23.4321 8.48C23.8911 8.789 24.5121 8.665 24.8201 8.207ZM4.65212 22.189C4.52012 21.474 4.45312 20.737 4.45312 20C4.45312 13.383 9.83612 8 16.4531 8C19.7661 8 22.8511 9.321 25.1401 11.721C25.5211 12.121 25.5061 12.754 25.1061 13.135C24.7071 13.516 24.0741 13.501 23.6921 13.101C21.7851 11.102 19.2141 10 16.4531 10C10.9391 10 6.45312 14.486 6.45312 20C6.45312 20.615 6.50912 21.23 6.61912 21.826C6.71912 22.369 6.36013 22.891 5.81712 22.991C5.75612 23.002 5.69513 23.008 5.63513 23.008C5.16213 23.008 4.74113 22.671 4.65212 22.189Z',
    },
  ],
});

register('pause', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z',
    },
  ],
});

register('play', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z',
    },
  ],
});

register('add-circle', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z',
    },
  ],
});

register('cancel', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
    },
  ],
});

register('cancel-bg', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 11.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
      opacity: '.75',
      fill: '#FFF',
    },
    {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z',
    },
  ],
});

register('visibility-off', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z',
    },
  ],
});

register('sort', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z',
    },
  ],
});

register('drag', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    },
  ],
});

register('logout', {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z',
    },
    {
      d: 'M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z',
    },
  ],
});
